import i18next from 'i18next';

import {
  GENERIC_MODAL_CLOSE_BUTTON,
  GENERIC_MODAL_IMPORT_BUTTON,
  GENERIC_MODAL_CANCEL_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';
import { IMPORT_MODAL_STEPS, getValidationFileConfig } from '@commons/Modals/MultiStepModal';

import ImportExcelFileModal from '@backoffice/components/ImportExcelFileModal';

const COMMON_FILE_CONFIG = {
  width: '542px',
  height: 'auto',
  component: ImportExcelFileModal,
};

export const getUpdateTranslationsModalConfig = (step, props) => {
  switch (step) {
    case IMPORT_MODAL_STEPS.SELECT_FILE:
      return getSelectFileConfig(props);
    case IMPORT_MODAL_STEPS.VALIDATE_FILE:
      return getValidationFileConfig({
        ...props,
        title: i18next.t('ADMIN.TRANSLATIONS.IMPORT_MODAL_TITLE'),
        subTitle: i18next.t('ADMIN.TRANSLATIONS.IMPORT_MODAL_SUBTITLE'),
      });
    case IMPORT_MODAL_STEPS.VALIDATED_FILE:
      return getValidatedFileConfig(props);
    case IMPORT_MODAL_STEPS.ERROR_FILE:
      return getErrorFileConfig(props);
    default:
      return {
        width: '542px',
        height: 'auto',
        component: ImportExcelFileModal,
      };
  }
};

export const getSelectFileConfig = ({ selectedFile, handleFileChange, handleCloseCleanUp }) => ({
  ...COMMON_FILE_CONFIG,
  type: 'action',
  title: i18next.t('ADMIN.TRANSLATIONS.IMPORT_MODAL_TITLE'),
  icon: '/images/inpulse/file-upload-black-small.svg',
  handleCloseCleanUp,
  data: {
    subTitle: i18next.t('ADMIN.TRANSLATIONS.IMPORT_MODAL_SUBTITLE'),
    selectedFile,
    setSelectedFile: (file) => handleFileChange(file),
  },
  actions: [
    {
      ...GENERIC_MODAL_CANCEL_BUTTON(),
      handleClick: handleCloseCleanUp,
    },
    {
      ...GENERIC_MODAL_IMPORT_BUTTON(),
      isDisabled: true,
      handleClick: () => false,
    },
  ],
});

export const getErrorFileConfig = ({ updatedFile, handleCloseCleanUp, exportErrors = null }) => {
  const data = {
    subTitle: i18next.t('ADMIN.TRANSLATIONS.IMPORT_MODAL_SELECT_FILE_ERROR_SUBTITLE'),
    additionalText: !exportErrors
      ? i18next.t('ADMIN.TRANSLATIONS.IMPORT_MODAL_FILE_IMPORT_ERROR_SUBTITLE')
      : i18next.t('ADMIN.TRANSLATIONS.IMPORT_MODAL_SUBTITLE_UNVALIDATED_LINES'),
    validatedFile: false,
    selectedFile: updatedFile,
    ...(!!exportErrors && {
      exportXLS: exportErrors,
    }),
  };

  return {
    ...COMMON_FILE_CONFIG,
    type: 'error',
    title: i18next.t('ADMIN.TRANSLATIONS.IMPORT_MODAL_SELECT_FILE_ERROR_TITLE'),
    icon: '/images/inpulse/info-white-small.svg',
    handleCloseCleanUp,
    data,
    actions: [
      {
        ...GENERIC_MODAL_CLOSE_BUTTON(),
        handleClick: handleCloseCleanUp,
      },
    ],
  };
};

const getValidatedFileConfig = ({ updatedFile = null, handleFileImport, handleCloseCleanUp }) => ({
  ...COMMON_FILE_CONFIG,
  type: 'success',
  title: i18next.t('GENERAL.IMPORT_FILE_NO_ERROR_TITLE_MODAL'),
  icon: '/images/inpulse/check-white-small.svg',
  handleCloseCleanUp,
  data: {
    subTitle: i18next.t('ADMIN.TRANSLATIONS.IMPORT_MODAL_SUBTITLE_SUCCESS'),
    validatedFile: true,
    selectedFile: updatedFile,
  },
  actions: [
    {
      ...GENERIC_MODAL_IMPORT_BUTTON(),
      handleClick: handleFileImport,
    },
  ],
});
